/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalMessageInput
 */
export interface PortalMessageInput {
    /**
     * 
     */
    client_message_id: string;
    /**
     * 
     */
    body: string;
    /**
     * 
     */
    request_item_id?: string | null;
    /**
     * 
     */
    in_reply_to_message_id?: string | null;
}

/**
 * Check if a given object implements the PortalMessageInput interface.
 */
export function instanceOfPortalMessageInput(value: object): value is PortalMessageInput {
    if (!('client_message_id' in value) || value['client_message_id'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function PortalMessageInputFromJSON(json: any): PortalMessageInput {
    return PortalMessageInputFromJSONTyped(json, false);
}

export function PortalMessageInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessageInput {
    if (json == null) {
        return json;
    }
    return {
        
        'client_message_id': json['client_message_id'],
        'body': json['body'],
        'request_item_id': json['request_item_id'] === undefined ? undefined : json['request_item_id'] === null ? null : json['request_item_id'],
        'in_reply_to_message_id': json['in_reply_to_message_id'] === undefined ? undefined : json['in_reply_to_message_id'] === null ? null : json['in_reply_to_message_id'],
    };
}

export function PortalMessageInputToJSON(json: any): PortalMessageInput {
    return PortalMessageInputToJSONTyped(json, false);
}

export function PortalMessageInputToJSONTyped(value?: PortalMessageInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_message_id': value['client_message_id'],
        'body': value['body'],
        'request_item_id': value['request_item_id'],
        'in_reply_to_message_id': value['in_reply_to_message_id'],
    };
}

